<template>
  <div v-if="mainStore.currentStepContent" class="flex items-center space-x-6 whitespace-nowrap">
    <div
      v-if="mainStore.currentStepContent.stats"
      class="hidden font-medium text-dark md:block"
      v-html="mainStore.currentStepContent.stats"
    ></div>
    <div v-if="mainStore.content.avatarUrls.length >= count" class="hidden flex-row-reverse xl:flex">
      <Provider v-for="(avatar, index) in avatars" ref="providers" :key="index" :url="avatar" :logged="true" class="-mr-3" />
    </div>
  </div>
</template>

<script>
import Provider from './Provider.vue'
import { mapStores } from 'pinia'
import { useMainStore } from '@/apps/fast/store'

export default {
  components: { Provider },
  data() {
    return {
      count: 5,
      avatars: []
    }
  },
  computed: {
    ...mapStores(useMainStore)
  },
  mounted() {
    for (let i = 0; i < this.count; i++) {
      this.changeAvatar(i)
    }
    this.scheduleTurnOver()
  },
  methods: {
    changeAvatar(index) {
      const newUrl = this.pickNewAvatar()
      if (newUrl === null) {
        return
      }

      this.$set(this.avatars, index, newUrl)

      if (typeof this.$refs.providers !== 'undefined' && typeof this.$refs.providers[index] !== 'undefined') {
        this.$refs.providers[index].changeTo(newUrl)
      }
    },
    pickNewAvatar() {
      const urls = this.mainStore.content.avatarUrls
      for (let i = 0; i < this.count; i++) {
        const url = urls[Math.floor(Math.random() * urls.length)]
        if (this.avatars.indexOf(url) < 0) {
          return url
        }
      }
      return null
    },
    turnOver() {
      this.changeAvatar(Math.floor(Math.random() * this.count))
      this.scheduleTurnOver()
    },
    scheduleTurnOver() {
      setTimeout(() => this.turnOver(), Math.random() * 12000 + 5000)
    }
  }
}
</script>
